module.exports = __webpack_public_path__ + "static/img/adenomiose.8858e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adenomiose.png
// module id = Lx3F
// module chunks = 1